import { dynamicParameter } from '../service/mixin-service';
import axios from "axios";

const defaultGetData = response => response?.data?.data;

export default function dynamicData(name, path, getData = defaultGetData, params = { page: 'unpaged' }, defaultData = []) {
  const getPath = dynamicParameter(path);
  const getParams = dynamicParameter(params);
  const restConfig = self => ({ url: '/rest/v4/' + getPath(self), params: getParams(self) });

  const RESPONSE = `${name}_response`;
  const PENDING = `${name}_pending`;
  const LOADING = `_${name}_load`;

  var _failed = false;

  return {
    data() {
      return {
        [RESPONSE]: null,
        [PENDING]: false,
      }
    },
    methods: {
      async [LOADING]() {
        this[PENDING] = true;

        try {
          this[RESPONSE] = await axios({ ...restConfig(this), method: 'get' });
          return this[RESPONSE];
        } catch (e) {
          _failed = true;
          throw e;
        } finally {
          this[PENDING] = false;
        }
      },
      async [`${name}_promise`]() {
        if (this[RESPONSE]) { return getData(this[RESPONSE]) }
        return getData(await this[LOADING]());
      },
      [`_${name}_reload`]() {
        this[RESPONSE] = null;
      }
    },
    computed: {
      [name]: {
        get() {
          if (_failed) { return defaultData }

          if (!this[RESPONSE] && !this[PENDING]) {
            this[LOADING]();
            return defaultData;
          }

          if (this[PENDING]) {
            return defaultData;
          }

          return getData(this[RESPONSE]);
        },
        async set(newValue) {
          this[RESPONSE] = newValue;
        }
      },

    },
  }
}
